import React, {FC} from 'react'
import {useIntl} from 'react-intl'
import {KTCard, KTCardBody} from '../../../_metronic/helpers'

export const LoadingState: FC = () => {
  const {formatMessage} = useIntl()
  return (
    <KTCard>
      <KTCardBody className='py-9 text-center'>
        <span className='spinner-border spinner-border-sm align-middle me-2'></span>
        {formatMessage({id: 'Loading'})}
      </KTCardBody>
    </KTCard>
  )
}

export const ErrorState: FC<{message: string | null}> = ({message}) => {
  return (
    <KTCard>
      <KTCardBody className='py-9 text-center text-danger'>
        {message || 'An error occurred.'} {/* Provide a default message */}
      </KTCardBody>
    </KTCard>
  )
}

export const NoDataState: FC = () => {
    const {formatMessage} = useIntl()
    return (
        <KTCard>
            <KTCardBody className='py-9 text-center'>
                {formatMessage({id: 'no_data'})}
            </KTCardBody>
        </KTCard>
    )
}
